export default "__VITE_ASSET__C$$qPglR__"